export default __webpack_public_path__ + "static/media/log-out.c35b61d9.svg";